export const getDefaultState = () => {
  return {
    locationHistory: []
  };
};

export default {
  ...getDefaultState()
};
